// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared page toolbar — filter + search controls used across list pages */

.page-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* --- Filter button + dropdown --- */
.page-filter {
  position: relative;
  flex-shrink: 0;
}

.page-filter-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  transition:
    background-color 0.15s,
    border-color 0.15s,
    color 0.15s,
    box-shadow 0.15s;
}

.page-filter-btn svg {
  width: 18px;
  height: 18px;
}

.page-filter-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #174078;
}

.page-filter-btn.is-open {
  background: #f0f4ff;
  border-color: #93b4e8;
  color: #174078;
}

.page-filter-btn.is-active {
  background: #f0f4ff;
  border-color: #174078;
  color: #174078;
}

.page-filter-dot {
  position: absolute;
  top: 7px;
  right: 7px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #f97316;
  border: 1.5px solid #fff;
}

.page-filter-menu {
  position: absolute;
  top: calc(100% + 6px);
  z-index: 120;
  min-width: 190px;
  max-width: 260px;
  max-height: 320px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  padding: 6px;
}

.page-filter-menu--right {
  right: 0;
}

.page-filter-menu--left {
  left: 0;
}

.page-filter-option {
  display: block;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: #374151;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition:
    background-color 0.12s,
    color 0.12s;
}

.page-filter-option:hover {
  background: #f3f4f6;
}

.page-filter-option.is-selected {
  background: #f0f4ff;
  color: #174078;
}

/* --- Search bar --- */
.page-search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  min-width: 200px;
  max-width: 320px;
  flex: 1 1 220px;
  padding: 0 14px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
}

.page-search-bar:focus-within {
  border-color: #93b4e8;
  box-shadow: 0 0 0 3px rgba(23, 64, 120, 0.08);
}

.page-search-bar .page-search-icon {
  width: 16px;
  height: 16px;
  color: #9ca3af;
  flex-shrink: 0;
}

.page-search-bar input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #111827;
}

.page-search-bar input::placeholder {
  color: #9ca3af;
}

.page-search-bar input:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

@media (max-width: 768px) {
  .page-toolbar {
    width: 100%;
  }

  .page-search-bar {
    max-width: none;
    flex: 1 1 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/compoonents/PageToolbar/PageToolbar.css"],"names":[],"mappings":"AAAA,0EAA0E;;AAE1E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf;;;;oBAIkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;;eAEa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;;oBAEkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF","sourcesContent":["/* Shared page toolbar — filter + search controls used across list pages */\n\n.page-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n/* --- Filter button + dropdown --- */\n.page-filter {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.page-filter-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: #fff;\n  color: #64748b;\n  cursor: pointer;\n  transition:\n    background-color 0.15s,\n    border-color 0.15s,\n    color 0.15s,\n    box-shadow 0.15s;\n}\n\n.page-filter-btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n.page-filter-btn:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  color: #174078;\n}\n\n.page-filter-btn.is-open {\n  background: #f0f4ff;\n  border-color: #93b4e8;\n  color: #174078;\n}\n\n.page-filter-btn.is-active {\n  background: #f0f4ff;\n  border-color: #174078;\n  color: #174078;\n}\n\n.page-filter-dot {\n  position: absolute;\n  top: 7px;\n  right: 7px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #f97316;\n  border: 1.5px solid #fff;\n}\n\n.page-filter-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  z-index: 120;\n  min-width: 190px;\n  max-width: 260px;\n  max-height: 320px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n  padding: 6px;\n}\n\n.page-filter-menu--right {\n  right: 0;\n}\n\n.page-filter-menu--left {\n  left: 0;\n}\n\n.page-filter-option {\n  display: block;\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  border-radius: 7px;\n  background: transparent;\n  color: #374151;\n  font-size: 13px;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition:\n    background-color 0.12s,\n    color 0.12s;\n}\n\n.page-filter-option:hover {\n  background: #f3f4f6;\n}\n\n.page-filter-option.is-selected {\n  background: #f0f4ff;\n  color: #174078;\n}\n\n/* --- Search bar --- */\n.page-search-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  min-width: 200px;\n  max-width: 320px;\n  flex: 1 1 220px;\n  padding: 0 14px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n\n.page-search-bar:focus-within {\n  border-color: #93b4e8;\n  box-shadow: 0 0 0 3px rgba(23, 64, 120, 0.08);\n}\n\n.page-search-bar .page-search-icon {\n  width: 16px;\n  height: 16px;\n  color: #9ca3af;\n  flex-shrink: 0;\n}\n\n.page-search-bar input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 14px;\n  color: #111827;\n}\n\n.page-search-bar input::placeholder {\n  color: #9ca3af;\n}\n\n.page-search-bar input:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n@media (max-width: 768px) {\n  .page-toolbar {\n    width: 100%;\n  }\n\n  .page-search-bar {\n    max-width: none;\n    flex: 1 1 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
